<template>
  <div class="clientes">
    <div class="page-header">
      <button @click="showModal = true" class="btn btn-success">
        <i class="fas fa-plus"></i> Novo Cliente
      </button>
    </div>
    
    <div class="table-container">
      <table class="table">
        <thead>
          <tr>
            <th class="col-name">Nome Completo</th>
            <th class="col-doc">RG</th>
            <th class="col-doc">CPF</th>
            <th class="col-address">Endereço</th>
            <th class="col-city">Cidade</th>
            <th class="col-phone">Telefone 1</th>
            <th class="col-phone">Telefone 2</th>
            <th class="col-actions">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="cliente in clientes" :key="cliente.id">
            <td class="col-name">{{ cliente.fullName }}</td>
            <td class="col-doc">{{ cliente.rg || '-' }}</td>
            <td class="col-doc">{{ formatCPF(cliente.cpf) }}</td>
            <td class="col-address">{{ formatEnderecoCompleto(cliente) }}</td>
            <td class="col-city">{{ cliente.city }}</td>
            <td class="col-phone">{{ formatPhone(cliente.phone1) }}</td>
            <td class="col-phone">{{ cliente.phone2 ? formatPhone(cliente.phone2) : '-' }}</td>
            <td class="actions-cell">
              <button @click="editarCliente(cliente)" class="btn-action edit" title="Editar">
                <i class="fas fa-edit"></i>
              </button>
              <button @click="deletarCliente(cliente.id)" class="btn-action delete" title="Deletar">
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          <tr v-if="clientes.length === 0 && !loading">
            <td colspan="8" class="no-data">Nenhum cliente cadastrado</td>
          </tr>
          <tr v-if="loading">
            <td colspan="8" class="no-data">Carregando...</td>
          </tr>
        </tbody>
      </table>
    </div>

    <PaginationControls
      :limit="limit"
      :offset="offset"
      :page-items-count="pageItemsCount"
      @prev="onPrevPage"
      @next="onNextPage"
    />
    
    <!-- Modal de Cadastro -->
    <div v-if="showModal" class="modal">
      <div class="modal-content">
        <h2>{{ editingId ? 'Editar Cliente' : 'Cadastrar Novo Cliente' }}</h2>
        
        <form @submit.prevent="salvarCliente">
          <div class="form-group">
            <label for="fullName">Nome Completo *</label>
            <input type="text" id="fullName" v-model="novoCliente.fullName" required>
          </div>
          
          <div class="form-group">
            <label for="rg">RG</label>
            <input 
              type="text" 
              id="rg" 
              v-model="novoCliente.rg" 
              @input="formatRG"
              maxlength="12"
              placeholder="00.000.000-0"
            >
          </div>
          
          <div class="form-group">
            <label for="cpf">CPF (11 dígitos) *</label>
            <input 
              type="text" 
              id="cpf" 
              v-model="novoCliente.cpf" 
              @input="formatCPFInput"
              maxlength="14"
              placeholder="000.000.000-00"
              required
            >
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="phone1">Telefone 1 *</label>
              <input 
                type="tel" 
                id="phone1" 
                v-model="novoCliente.phone1" 
                @input="formatPhoneInput"
                maxlength="15"
                placeholder="(00) 00000-0000"
                required
              >
            </div>
            
            <div class="form-group">
              <label for="phone2">Telefone 2</label>
              <input 
                type="tel" 
                id="phone2" 
                v-model="novoCliente.phone2" 
                @input="formatPhone2Input"
                maxlength="15"
                placeholder="(00) 00000-0000"
              >
            </div>
          </div>
          
          <div class="form-group">
            <label for="street">Rua *</label>
            <input type="text" id="street" v-model="novoCliente.street" required>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="number">Número *</label>
              <input type="text" id="number" v-model="novoCliente.number" required>
            </div>
            
            <div class="form-group">
              <label for="complement">Complemento</label>
              <input type="text" id="complement" v-model="novoCliente.complement">
            </div>
          </div>
          
          <div class="form-row">
            <div class="form-group">
              <label for="neighborhood">Bairro *</label>
              <input type="text" id="neighborhood" v-model="novoCliente.neighborhood" required>
            </div>
            
            <div class="form-group">
              <label for="city">Cidade *</label>
              <input type="text" id="city" v-model="novoCliente.city" required>
            </div>
          </div>
          
          <div class="form-actions">
            <button type="submit" class="btn btn-success">
              <i class="fas fa-save"></i> Salvar
            </button>
            <button type="button" class="btn btn-secondary" @click="cancelar">
              <i class="fas fa-times"></i> Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>

    <div v-if="showNoticeModal" class="modal" @click.self="showNoticeModal = false">
      <div class="modal-content notice-modal">
        <h2>Aviso</h2>
        <p>{{ noticeMessage }}</p>
        <div class="modal-actions">
          <button type="button" class="btn btn-primary" @click="showNoticeModal = false">
            Fechar
          </button>
        </div>
      </div>
    </div>

    <div v-if="showDeleteModal" class="modal" @click.self="fecharDeleteModal">
      <div class="modal-content notice-modal">
        <h2>Confirmar exclusão</h2>
        <p>Tem certeza que deseja deletar este cliente?</p>
        <div class="modal-actions">
          <button type="button" class="btn btn-secondary" @click="fecharDeleteModal">
            Cancelar
          </button>
          <button type="button" class="btn btn-primary" @click="confirmarDeleteCliente">
            Deletar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, computed, onMounted, watch } from 'vue'
import { useStore } from 'vuex'

import PaginationControls from '@/components/PaginationControls.vue'
import { usePagination } from '@/composables/usePagination'
import type { Customer, Honorary } from '@/types'

export default {
  name: 'Clientes',
  components: { PaginationControls },
  setup() {
    const store = useStore()
    
    const showModal = ref(false)
    const showNoticeModal = ref(false)
    const showDeleteModal = ref(false)
    const clienteParaDeletar = ref<string | null>(null)
    const noticeMessage = ref('')
    const editingId = ref<string | null>(null)
    const novoCliente = ref({
      fullName: '',
      rg: '',
      cpf: '',
      phone1: '',
      phone2: '',
      street: '',
      number: '',
      complement: '',
      neighborhood: '',
      city: ''
    })
    
    const clientes = computed(() => store.state.clientes)
    const honorarios = computed<Honorary[]>(() => store.state.honorarios as Honorary[])
    const loading = computed(() => store.state.loading)
    const { limit, offset, nextPage, prevPage, reset } = usePagination(50)
    const pageItemsCount = ref(0)
    
    // Carregar clientes ao montar o componente
    onMounted(async () => {
      try {
        await store.dispatch('loadClientes', { limit: limit.value, offset: offset.value })
        pageItemsCount.value = store.state.clientes.length
      } catch (error: any) {
        alert('Não foi possível carregar. Tente novamente.')
      }
    })
    
    // Recarregar quando mudar limit/offset
    watch([limit, offset], async () => {
      try {
        await store.dispatch('loadClientes', { limit: limit.value, offset: offset.value })
        pageItemsCount.value = store.state.clientes.length
      } catch {
        alert('Não foi possível carregar. Tente novamente.')
      }
    })
    
    const onNextPage = () => {
      // desabilitado na UI quando não houver próxima; aqui apenas avança
      nextPage()
    }
    const onPrevPage = () => {
      prevPage()
    }
    
    const formatRG = (event: Event) => {
      const target = event.target as HTMLInputElement
      let value = target.value.replace(/\D/g, '')
      if (value.length <= 9) {
        value = value.replace(/(\d{2})(\d{3})(\d{3})(\d{1})/, '$1.$2.$3-$4')
        novoCliente.value.rg = value
      }
    }
    
    // Função para formatar CPF no input (recebe evento)
    const formatCPFInput = (event: Event) => {
      const target = event.target as HTMLInputElement
      let value = target.value.replace(/\D/g, '')
      if (value.length <= 11) {
        if (value.length === 11) {
          value = value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
        }
        novoCliente.value.cpf = value
      }
    }
    
    // Função para formatar CPF para exibição (recebe string)
    const formatCPF = (cpf: string) => {
      if (!cpf || typeof cpf !== 'string') return cpf
      const numbers = cpf.replace(/\D/g, '')
      if (numbers.length === 11) {
        return numbers.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')
      }
      return cpf
    }
    
    const formatPhone = (phone: string) => {
      const numbers = phone.replace(/\D/g, '')
      if (numbers.length === 11) {
        return numbers.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
      } else if (numbers.length === 10) {
        return numbers.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
      }
      return phone
    }
    
    const formatPhoneInput = (event: Event) => {
      const target = event.target as HTMLInputElement
      let value = target.value.replace(/\D/g, '')
      if (value.length <= 11) {
        if (value.length === 11) {
          value = value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
        } else if (value.length === 10) {
          value = value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
        }
        novoCliente.value.phone1 = value
      }
    }
    
    const formatPhone2Input = (event: Event) => {
      const target = event.target as HTMLInputElement
      let value = target.value.replace(/\D/g, '')
      if (value.length <= 11) {
        if (value.length === 11) {
          value = value.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3')
        } else if (value.length === 10) {
          value = value.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3')
        }
        novoCliente.value.phone2 = value
      }
    }
    
    const formatEnderecoCompleto = (cliente: Customer) => {
      const complement = cliente.complement ? `, ${cliente.complement}` : ''
      return `${cliente.street}, ${cliente.number}${complement} - ${cliente.neighborhood}`
    }
    
    const salvarCliente = async () => {
      try {
        const cpfNumbers = novoCliente.value.cpf.replace(/\D/g, '')
        
        if (cpfNumbers.length !== 11) {
          noticeMessage.value = 'CPF inválido. Informe exatamente 11 dígitos.'
          showNoticeModal.value = true
          return
        }
        
        if (editingId.value) {
          await store.dispatch('atualizarCliente', {
            id: editingId.value,
            data: { ...novoCliente.value }
          })
          noticeMessage.value = 'Cliente atualizado com sucesso!'
          showNoticeModal.value = true
        } else {
          await store.dispatch('cadastrarCliente', { ...novoCliente.value })
          noticeMessage.value = 'Cliente cadastrado com sucesso!'
          showNoticeModal.value = true
        }
        
        resetForm()
        showModal.value = false
        await store.dispatch('loadClientes', { limit: limit.value, offset: offset.value })
        pageItemsCount.value = store.state.clientes.length
      } catch (error: any) {
        noticeMessage.value = error.message || 'Erro ao salvar cliente'
        showNoticeModal.value = true
      }
    }
    
    const editarCliente = (cliente: Customer) => {
      editingId.value = cliente.id
      novoCliente.value = {
        fullName: cliente.fullName,
        rg: cliente.rg || '',
        cpf: formatCPF(cliente.cpf),
        phone1: formatPhone(cliente.phone1),
        phone2: cliente.phone2 ? formatPhone(cliente.phone2) : '',
        street: cliente.street,
        number: cliente.number,
        complement: cliente.complement || '',
        neighborhood: cliente.neighborhood,
        city: cliente.city
      }
      showModal.value = true
    }
    
    const deletarCliente = async (id: string) => {
      const honorariosVinculados = honorarios.value.filter((honorario) => honorario.customerId === id)

      if (honorariosVinculados.length > 0) {
        noticeMessage.value = 'Nao e possivel deletar este cliente porque existem honorarios vinculados a ele. Exclua ou transfira os honorarios antes de remover o cliente.'
        showNoticeModal.value = true
        return
      }

      clienteParaDeletar.value = id
      showDeleteModal.value = true
    }

    const fecharDeleteModal = () => {
      showDeleteModal.value = false
      clienteParaDeletar.value = null
    }

    const confirmarDeleteCliente = async () => {
      if (!clienteParaDeletar.value) {
        return
      }

      const clienteId = clienteParaDeletar.value
      fecharDeleteModal()

       const finalizarExclusaoComSucesso = async () => {
        noticeMessage.value = 'Cliente excluído com sucesso!'
        showNoticeModal.value = true

        await Promise.allSettled([
          store.dispatch('loadHonorarios'),
          store.dispatch('loadClientes', { limit: limit.value, offset: offset.value })
        ])
        pageItemsCount.value = store.state.clientes.length
      }

      try {
        await store.dispatch('deletarCliente', clienteId)
        await finalizarExclusaoComSucesso()
      } catch (error: any) {
        if (typeof error?.message === 'string' && error.message.includes('Cliente não encontrado')) {
          await finalizarExclusaoComSucesso()
          return
        }

        noticeMessage.value = error.message || 'Erro ao deletar cliente'
        showNoticeModal.value = true
      }
    }
    
    const cancelar = () => {
      resetForm()
      showModal.value = false
    }
    
    const resetForm = () => {
      editingId.value = null
      novoCliente.value = {
        fullName: '',
        rg: '',
        cpf: '',
        phone1: '',
        phone2: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: ''
      }
    }

    return {
      showModal,
      showNoticeModal,
      showDeleteModal,
      noticeMessage,
      novoCliente,
      clientes,
      loading,
      limit,
      offset,
      pageItemsCount,
      onNextPage,
      onPrevPage,
      editingId,
      salvarCliente,
      editarCliente,
      deletarCliente,
      confirmarDeleteCliente,
      fecharDeleteModal,
      cancelar,
      formatRG,
      formatCPFInput,
      formatCPF,
      formatPhone,
      formatPhoneInput,
      formatPhone2Input,
      formatEnderecoCompleto
    }
  }
}
</script>

<style scoped>
.page-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-bottom: 30px;
}

.table-container {
  background-color: var(--bg-secondary);
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  box-shadow: 0 2px 10px var(--shadow);
}

.table {
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
}

.table th,
.table td {
  padding: 16px 14px;
  vertical-align: top;
}

.table th {
  text-align: left;
  color: var(--text-primary);
  font-weight: 600;
  border-bottom: 1px solid var(--border-color);
}

.table td {
  color: var(--text-primary);
  border-bottom: 1px solid color-mix(in srgb, var(--border-color) 70%, transparent);
  line-height: 1.45;
}

.table tbody tr:hover {
  background: color-mix(in srgb, var(--bg-primary) 55%, transparent);
}

.col-name {
  min-width: 240px;
}

.col-doc,
.col-phone,
.col-city,
.col-actions {
  white-space: nowrap;
}

.col-doc {
  min-width: 115px;
}

.col-phone {
  min-width: 130px;
}

.col-city {
  min-width: 120px;
}

.col-address {
  min-width: 230px;
}

.col-actions {
  width: 1%;
}

.no-data {
  text-align: center;
  color: var(--text-secondary);
  font-style: italic;
  padding: 40px !important;
}

.form-group textarea {
  width: 100%;
  padding: 10px;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  background-color: var(--bg-primary);
  color: var(--text-primary);
  resize: vertical;
  font-family: inherit;
}

.form-actions {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}

.btn-success {
  background: linear-gradient(135deg, #1f9d55, #28b463);
  color: white;
  border: none;
}

.btn-success:hover {
  background: linear-gradient(135deg, #18874a, #229954);
}

.modal-actions {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px;
  margin-top: 20px;
}

.modal-content h2 {
  color: var(--text-primary);
  margin-bottom: 20px;
  text-align: center;
}

.modal-content {
  scrollbar-width: thin;
  scrollbar-color: var(--border-color) transparent;
}

.modal-content::-webkit-scrollbar {
  width: 10px;
}

.modal-content::-webkit-scrollbar-track {
  background: transparent;
}

.modal-content::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border: 2px solid var(--bg-primary);
  border-radius: 999px;
}

.modal-content::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}

.notice-modal {
  max-width: 460px;
  text-align: left;
  background: color-mix(in srgb, var(--bg-secondary) 94%, var(--bg-primary));
  border: 1px solid color-mix(in srgb, #4a91ff 38%, var(--border-color));
  box-shadow: 0 16px 42px color-mix(in srgb, #001946 28%, transparent);
}

.notice-modal h2 {
  color: color-mix(in srgb, #6aa8ff 72%, var(--text-primary));
  margin-bottom: 12px;
  text-align: left;
}

.notice-modal p {
  color: var(--text-primary);
  line-height: 1.5;
  opacity: 0.92;
}

.form-row {
  display: flex;
  gap: 15px;
}

.form-row .form-group {
  flex: 1;
}

.actions-cell {
  white-space: nowrap;
  text-align: right;
}

.btn-action {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: 1px solid;
  padding: 5px 8px;
  border-radius: 3px;
  cursor: pointer;
  font-size: 12px;
  transition: all 0.3s ease;
}

.btn-action + .btn-action {
  margin-left: 5px;
}

.btn-action.edit {
  border-color: #f4b400;
  color: #f4b400;
}

.btn-action.edit:hover {
  background-color: #f4b400;
  color: #1f1f1f;
}

.btn-action.delete {
  border-color: #f44336;
  color: #f44336;
}

.btn-action.delete:hover {
  background-color: #f44336;
  color: white;
}

@media (max-width: 768px) {
  .page-header,
  .form-actions,
  .modal-actions,
  .form-row {
    flex-direction: column;
    align-items: stretch;
  }

  .table {
    min-width: 920px;
  }

  .modal-content h2 {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .page-header {
    margin-bottom: 20px;
  }

  .table {
    min-width: 820px;
  }

  .actions-cell {
    min-width: 104px;
  }
}
</style>

